module.exports = __webpack_public_path__ + "static/media/1-0.c0331081.svg";